import { Link } from 'react-router-dom';

const footerLinks = {
  content: [
    { label: '榴莲视频', href: '/category/liulian' },
    { label: '红杏视频', href: '/category/hongxing' },
    { label: '电影', href: '/category/movie' },
    { label: '电视剧', href: '/category/tv' },
    { label: '综艺', href: '/category/variety' },
    { label: '动漫', href: '/category/anime' },
    { label: '纪录片', href: '/category/documentary' },
  ],
  about: [
    { label: '关于我们', href: '/about' },
    { label: '品牌介绍', href: '/about#intro' },
    { label: '用户口碑', href: '/about#reputation' },
    { label: '联系我们', href: '/about#contact' },
  ],
  support: [
    { label: '观影指南', href: '/article/a4' },
    { label: '常见问题', href: '/about#faq' },
    { label: '用户协议', href: '/about#terms' },
    { label: '隐私政策', href: '/about#privacy' },
  ],
};

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="container-main py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="text-lg font-bold text-background-50 mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              向日葵视频
            </h4>
            <p className="text-sm text-background-400 leading-relaxed">
              向日葵视频提供免费高清在线观看，榴莲视频、红杏视频等热播电影电视剧综艺全集，流畅不缓冲，在线播放体验佳。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">内容分类</h4>
            <ul className="space-y-2">
              {footerLinks.content.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">关于</h4>
            <ul className="space-y-2">
              {footerLinks.about.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 uppercase tracking-wider">帮助</h4>
            <ul className="space-y-2">
              {footerLinks.support.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
            <div className="mt-4">
              <p className="text-sm text-background-400 mb-2">订阅我们的更新</p>
              <NewsletterForm />
            </div>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-700/40">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-sm text-background-500">
              &copy; {new Date().getFullYear()} 向日葵视频. 保留所有权利.
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-400 hover:text-background-50 transition-all duration-200" aria-label="微博" rel="nofollow">
                <i className="ri-weibo-line" />
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-400 hover:text-background-50 transition-all duration-200" aria-label="微信" rel="nofollow">
                <i className="ri-wechat-line" />
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-800 hover:bg-primary-500 text-background-400 hover:text-background-50 transition-all duration-200" aria-label="B站" rel="nofollow">
                <i className="ri-bilibili-line" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

function NewsletterForm() {
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = form.querySelector<HTMLInputElement>('input[name="phone_alt"]');
    if (honeypot && honeypot.value.trim() !== '') return;

    const formData = new FormData(form);
    formData.delete('phone_alt');
    try {
      const response = await fetch('https://readdy.ai/api/form/d9n4haobdkpk99j7gg8g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      if (response.ok) {
        form.reset();
      }
    } catch (_) {
      // silently handle
    }
  };

  return (
    <form onSubmit={handleSubmit} className="flex gap-2" data-readdy-form="">
      <input
        type="text"
        name="phone_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="form-hp"
      />
      <input
        type="email"
        name="email"
        placeholder="输入邮箱"
        className="flex-1 h-9 px-3 text-sm bg-background-800 border border-background-700 rounded-lg text-background-100 placeholder-background-500 focus:outline-none focus:border-primary-400 transition-all duration-200"
      />
      <button
        type="submit"
        className="whitespace-nowrap h-9 px-4 text-sm bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg transition-all duration-200"
      >
        订阅
      </button>
    </form>
  );
}